import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicSizeIcon from "../DynamicSizeIcon";
import DynamicFontSize from "../DynamicFontSize";
import { useGlobalData } from "@/contexts/GlobalData";
interface TokenNotFoundPropsType extends GeneralPropsType {
  contentKey: string;
}
function TokenNotFound({
  children,
  className,
  contentKey
}: TokenNotFoundPropsType) {
  const {
    getIcon,
    translate
  } = useGlobalData();
  return <div className={clsx("flex flex-col items-center gap-4", styles.container, className)} data-sentry-component="TokenNotFound" data-sentry-source-file="index.tsx">
            <DynamicSizeIcon icon={getIcon(contentKey + "icon")} width={64} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx" />
            <div className="flex flex-col items-center gap-1.5">
                <DynamicFontSize fontSize={18} className="text-white font-semibold capitalize" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    {translate(contentKey + "title")}
                </DynamicFontSize>
                <DynamicFontSize fontSize={14} className="text-description" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    {translate(contentKey + "description")}
                </DynamicFontSize>
            </div>
        </div>;
}
export default TokenNotFound;